import { useQuery } from '@tanstack/react-query';
import { getServiceCategories } from '../apis/masterData';
import type { ServiceCategory } from '../apis/masterData';

/**
 * Query key factory for partner services
 */
export const partnerServiceKeys = {
    all: ['partner-services'] as const,
    lists: () => [...partnerServiceKeys.all, 'list'] as const,
    list: (filters: Record<string, unknown>) => [...partnerServiceKeys.lists(), filters] as const,
};

/**
 * Hook to fetch service categories with their subcategories
 */
export function useServiceCategories(search?: string) {
    return useQuery<ServiceCategory[], Error>({
        queryKey: partnerServiceKeys.list({ search }),
        queryFn: async () => {
            return await getServiceCategories(search);
        },
        staleTime: search ? 30 * 1000 : 10 * 60 * 1000, 
    });
}











